import axios from "@/app/Axios";

class Usuarios {
    async index() {
        try {
            const response = await axios.post("/user-all");
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }

    async desactivaractivarUsuario(userId) {
        try {
            const response = await axios.put(`/activar-usuarioplus/${userId}`);
            return response.data; // Puedes manejar la respuesta según tus necesidades
        } catch (error) {
            console.log(error);
            throw error; // Lanza el error para manejarlo en el componente Vue
        }
    }

    async buscarPorCedula(carnet) {
        try {
            const response = await axios.get(`/buscar-usuario/${carnet}`);
            return response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async crearUsuario(usuario) {
        try {
            const response = await axios.post("/crear-usuario", usuario)
            console.log("Esta es respuesta:", response.data);
            return response.data

        } catch (error) {
            if (error.response && error.response.status === 401) {
                return error.response.data;
            } else {
                console.log(error);
            }
        }
    }
    async obtenerUsuariosPorRol(rolId) {
        try {
            const response = await axios.get(`/users/by-role/${rolId}`);
            console.log("Esta es mi respuest de lServicio", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
}
export default Usuarios;
